import CitySEOHead from "@/components/feature/CitySEOHead";
import WichitaFallsHeroSection from "./components/HeroSection";
import WichitaFallsStickyNav from "./components/StickyNav";
import WichitaFallsProcessingTimeSection from "./components/ProcessingTimeSection";
import WichitaFallsServicesSection from "./components/ServicesSection";
import WichitaFallsLocalAreaSection from "./components/LocalAreaSection";
import WichitaFallsTravelTimingSection from "./components/TravelTimingSection";
import WichitaFallsDestinationsSection from "./components/DestinationsSection";
import WichitaFallsTestimonialsSection from "./components/TestimonialsSection";
import WichitaFallsAcceptanceFacilitiesSection from "./components/AcceptanceFacilitiesSection";
import WichitaFallsComparisonSection from "./components/ComparisonSection";
import WichitaFallsMistakesSection from "./components/MistakesSection";
import WichitaFallsHowItWorksSection from "./components/HowItWorksSection";
import WichitaFallsFAQSection, { faqs } from "./components/FAQSection";
import WichitaFallsHelpfulResourcesSection from "./components/HelpfulResourcesSection";
import WichitaFallsFinalCTA from "./components/FinalCTA";
import SEOCrossLinks from "@/components/feature/SEOCrossLinks";

const servicesSchema = [
  { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
  { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
  { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
  { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
  { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
  { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  { name: "Second Passport & Damaged", description: "Second passport issuance for frequent travelers and damaged passport replacement." },
];

const faqsMapped = faqs.map((f: { question: string; answer: string }) => ({ q: f.question, a: f.answer }));

export default function WichitaFallsPage() {
  return (
    <div className="font-sans">
      <CitySEOHead
        city="Wichita Falls"
        state="Texas"
        stateAbbr="TX"
        route="/cities/wichita-falls"
        title="Wichita Falls TX Passport Services — Emergency & Expedited | Fast Passport Center"
        description="Emergency and expedited passport services in Wichita Falls, TX — as fast as 24 hours. Sheppard AFB military families, MSU students, and North Texas professionals. A+ BBB rated registered State Dept. courier. No office visit required."
        geoPlacename="Wichita Falls, Texas"
        geoPosition="33.9137;-98.4934"
        faqs={faqsMapped}
        servicesSchema={servicesSchema}
        statePageName="Texas"
        statePageRoute="/states/texas"
      />
      <WichitaFallsHeroSection />
      <WichitaFallsStickyNav />
      <WichitaFallsProcessingTimeSection />
      <WichitaFallsServicesSection />
      <WichitaFallsLocalAreaSection />
      <WichitaFallsTravelTimingSection />
      <WichitaFallsDestinationsSection />
      <WichitaFallsTestimonialsSection />
      <WichitaFallsAcceptanceFacilitiesSection />
      <WichitaFallsComparisonSection />
      <WichitaFallsMistakesSection />
      <WichitaFallsHowItWorksSection />
      <WichitaFallsFAQSection />
      <WichitaFallsHelpfulResourcesSection />
      <SEOCrossLinks currentRoute="/cities/wichita-falls" state="TX" />
      <WichitaFallsFinalCTA />
    </div>
  );
}